export const config = {
  id: import.meta.env.VITE_USERFLOW_TOKEN,
};
